export const colors = {
  primary: '#1B5E20',
  primaryLight: '#4C8C4A',
  primaryPastel: '#A5D6A7',
  primaryDark: '#003300',
  secondary: '#FF6F00',
  secondaryLight: '#FFA040',
  secondaryDark: '#C43E00',
  background: '#F5F5F5',
  surface: '#FFFFFF',
  error: '#D32F2F',
  success: '#388E3C',
  warning: '#F57C00',
  info: '#1976D2',
  text: '#212121',
  textSecondary: '#757575',
  textLight: '#BDBDBD',
  border: '#E0E0E0',
  divider: '#EEEEEE',
  white: '#FFFFFF',
  black: '#000000',

  // Task status colors
  taskStatus: {
    PENDING: '#9E9E9E',
    ASSIGNED: '#2196F3',
    IN_PROGRESS: '#FF9800',
    COMPLETED: '#4CAF50',
  },

  // Order status colors
  status: {
    NEW: '#2196F3',
    IN_PROCESS: '#FF9800',
    COMPLETED: '#4CAF50',
    QUALITY_CHECK: '#607D8B',
    READY_FOR_TRIAL: '#9C27B0',
    DELIVERED: '#388E3C',
    CANCELLED: '#F44336',
  },
};
